import { createSlice } from '@reduxjs/toolkit'
import {  
  fetchWorkForceList,
  fetchCurrentWorkForceList, 
  deleteWorkForce,
  createUpdateWorkForce
   } from '../actions/workForcesAction'

export const workForces = createSlice({
  name: 'workForces',
  initialState: {
    workForce:null,
    returnList: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded:false,
    isManageWardPage:false,
    
  },
  reducers: {
    workforceReset: state => {
      state.error = null;
    },

   
    resetPopup: state => {
      state.isLoader= false;
      state.isRecordAdded= false;
      state.isRecordUpdated= false;
      state.error=null;
    },
  },
  extraReducers: {
    [fetchWorkForceList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchWorkForceList.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.returnList=payload?.data?.returnList
      state.isLoader= false;

    },
    [fetchWorkForceList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },
    [fetchCurrentWorkForceList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchCurrentWorkForceList.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.workForce=payload?.data?.workForce
      state.isLoader= false;

    },
    [fetchCurrentWorkForceList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },

    [createUpdateWorkForce.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
      state.isRecordUpdated= false;
    },
    [createUpdateWorkForce.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.returnList=payload?.data
      state.workForce=payload?.data
      state.isLoader= false;
      state.isRecordUpdated= true;
    },
    [createUpdateWorkForce.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
      state.isRecordUpdated= false;
    },
   
    [deleteWorkForce.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [deleteWorkForce.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [deleteWorkForce.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
  
  }
})

// Action creators are generated for each case reducer function
export const { workforceReset, resetPopup } = workForces.actions

export default workForces.reducer